import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';

const normalizeText = (value = '') =>
  value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('pt-BR');

const plainText = (value) => {
  if (typeof value === 'string') return value;
  if (!Array.isArray(value)) return '';
  return value
    .map((node) => node.text || plainText(node.children))
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
};

const normalizeLink = (item, index) => {
  if (typeof item === 'string') {
    return { href: item, title: item, key: `${item}-${index}` };
  }
  const target = Array.isArray(item?.href)
    ? item.href[0]
    : Array.isArray(item?.url)
      ? item.url[0]
      : null;
  const href =
    target?.['@id'] ||
    target?.url ||
    item?.href ||
    item?.url ||
    item?.link_url ||
    item?.target?.['@id'] ||
    item?.['@id'] ||
    '#';
  return {
    ...item,
    href,
    title:
      item?.title ||
      item?.label ||
      item?.text ||
      target?.title ||
      plainText(item?.value) ||
      href,
    description: item?.description || item?.body || '',
    key: item?.id || item?.['@id'] || `${href}-${index}`,
  };
};

const getItems = (data) => {
  const source =
    data.items || data.links || data.entries || data.value?.items || [];
  return (Array.isArray(source) ? source : []).map(normalizeLink);
};

const LegacyLinksView = ({ data }) => {
  const [query, setQuery] = React.useState('');
  const items = React.useMemo(() => getItems(data), [data]);
  const visibleItems = items.filter((item) =>
    normalizeText(`${item.title} ${item.description}`).includes(
      normalizeText(query),
    ),
  );

  return (
    <section className="ag-legacy-links ag-lista">
      <div className="ag-lista__panel">
        <div className="ag-lista__header">
          {data.headline || data.title || 'Links'}
        </div>
        <div className="ag-lista__search">
          <label className="ag-legacy-links__search">
            <span>Pesquisar nesta lista</span>
            <input
              type="search"
              value={query}
              placeholder="Digite uma palavra-chave"
              onChange={(event) => setQuery(event.target.value)}
            />
          </label>
        </div>
        <ul className="ag-lista__list">
          {visibleItems.map((item) => (
            <li key={item.key} className="ag-lista__item">
              <UniversalLink href={item.href}>
                <span className="ag-lista__item-main">
                  <strong className="ag-lista__item-title">{item.title}</strong>
                  {item.description && (
                    <small className="ag-lista__item-description">
                      {item.description}
                    </small>
                  )}
                </span>
              </UniversalLink>
            </li>
          ))}
        </ul>
        {!visibleItems.length && (
          <p className="ag-filtered-listing__empty">
            Nenhum link encontrado para a pesquisa.
          </p>
        )}
        <p className="ag-filtered-listing__count" aria-live="polite">
          {visibleItems.length} {visibleItems.length === 1 ? 'item' : 'itens'}
        </p>
      </div>
    </section>
  );
};

LegacyLinksView.propTypes = {
  data: PropTypes.object.isRequired,
};

export default LegacyLinksView;
